module.exports = __webpack_public_path__ + "img/item-1.41dd34d.png";